export function useShowLoadingBar({ fileStatus, percentComplete }) {
  const isImporting = fileStatus === 'IMPORTING' && percentComplete !== 100
  const showLoadingBar = isImporting && percentComplete !== undefined && percentComplete !== null
  const isProcessing = fileStatus === 'PROCESSING' || fileStatus === 'PROCESSED'
  return [{ isImporting, showLoadingBar, isProcessing }]
}
